/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { Activity } from "./Activity";
import { Pagination } from "../../commons/types/Pagination";
export const ActivityResponse = core.serialization.object({
    data: core.serialization.list(Activity),
    pagination: Pagination.optional(),
});
